import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, TextField } from "@mui/material";
import { InfinitySpin } from "react-loader-spinner";

class TopDish extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: this.props.match.params.restro_id,
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      totalPages: 1,
      total: "",
      per_page: 10,
      booking_status: "",
      booking_type: "",
    };
    this.restro_id = this.props.match.params.restro_id;
  }

  componentDidMount() {
    this.fetchData();
    // this.fetchRestData();
  }

  fetchData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let restro_id = this.state.restro_id;
    var page = this.state.currentPage;
    var per_page = this.state.per_page;
    var start_date = this.start_date;
    var end_date = this.end_date;

    axios
      .post(endpoints.getTopDishes, {
        restro_id,
        start_date,
        end_date,
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      });
  }
  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);

    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;

    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;

    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());
    const year = JSON.stringify(dates.getFullYear());
    const recent_date = month + "-" + date;

    const columns = [
      {
        selector: (row) => row.name,
        cellExport: (row) => row.name,
        sortable: true,
      },
      {
        selector: (row) => row.count,
        cellExport: (row) => row.count,
        sortable: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
    };

    const bFilter = async () => {
      if(!this.start_date && !this.end_date){
        alert("Please Select Any Filter");
        return

      }

      if(this.start_date && !this.end_date){
        alert("Please Select End Date");
        return

      }
      if(this.end_date && !this.start_date){
        alert("Please Select Start Date");
        return

      }
      var end_date = this.end_date;
      var start_date = this.start_date;

      let restro_id = this.state.restro_id;

      axios
        .post(endpoints.getTopDishes, {
          start_date,
          end_date,
          restro_id,
        })
        .then((response) => {
          this.setState({
            items: response.data.data,

            DataisLoaded: true,
          });
          //  console.log(response.data);
        });
    };
    const onStartChange = (e) => {
      this.start_date = e.target.value;
    };
    const onEndChange = (e) => {
      this.end_date = e.target.value;
    };

    const c = [
      {
        name: "NAME",
        count: "COUNT",
      },
    ];

    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
           color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Top Dishes</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  place="Start Date"
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    style={{ color: "white" }}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <div className="row mt-5">
          <DataTableExtensions {...tableData}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationPerPage={7}
              paginationRowsPerPageOptions={[7, 14, 21, 28, 35]}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(TopDish);
